import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import STATISTICS_PUBLIC from 'SharedDir/backend/endpoints/statistics-public';

export default class StatisticsPublicApiClass {
  async getIssues(params) {
    const { data } = await http({
      ...STATISTICS_PUBLIC.ISSUES,
      params,
    });
    return data;
  }

  async getIssuesDep() {
    const { data } = await http({
      ...STATISTICS_PUBLIC.ISSUES_DEP,
    });
    return data;
  }

  async getUsers() {
    const { data } = await http({
      ...STATISTICS_PUBLIC.USERS,
    });
    return data;
  }

  async getServiceByDepartment() {
    const { data } = await http({
      ...STATISTICS_PUBLIC.SERVICE_BY_DEPARTMENT,
    });
    return data;
  }
}
